import { generatePlatformValue, isCCTRLoggedIn } from "../../../platform/identifiers";
import { MissingObjectPropValues } from "../../../utils/ObjectUtils";
import { getAlmeSessionData } from "../../AlmeApp/AlmeAppSessionState";
function getDeviceFingerPrint() {
    const bb = window.IGLOO.getBlackbox && window.IGLOO.getBlackbox();
    return bb === null || bb === void 0 ? void 0 : bb.blackbox;
}
export function initializeTransmitParams(transmitParamsResponse, appConfig) {
    return new Promise((resolve, reject) => {
        var _a;
        const deviceFingerPrint = getDeviceFingerPrint();
        const transmitStartParams = JSON.parse(transmitParamsResponse);
        let platform = appConfig.main.platform;
        if (platform === "PSCC") {
            platform = (isCCTRLoggedIn()) ? "CCtr" : "CCtr IDP";
        }
        if (platform === "RC") {
            platform = generatePlatformValue(platform);
        }
        const transmitParams = {
            header: {
                trans_id: transmitStartParams.trans_id,
                client_id: transmitStartParams.client_id,
                channel_id: transmitStartParams.channel_id,
            },
            app_env: appConfig.TransmitEnv,
            bearer_token: transmitStartParams.access_token,
            device_fingerprint: deviceFingerPrint,
            client_type: transmitStartParams.client_type,
            language_code: appConfig.languageCode,
            session_key: transmitStartParams.session_key,
            user_id: (_a = getAlmeSessionData()) === null || _a === void 0 ? void 0 : _a.userId,
            user_auth_flow: transmitStartParams.user_auth_flow,
            origin: platform,
        };
        const missingPropValues = MissingObjectPropValues(transmitParams);
        if (missingPropValues.length >= 1) {
            reject("Missing following transmit props: " + missingPropValues.join(", "));
        }
        resolve(transmitParams);
    });
}
